/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import Alert from './Alert/index'
import EditAction from './EditAction/index'
import HideForFuture from './HideForFuture/index'
import Mandatory from './Mandatory/index'
import MultiValue from './MultiValue/index'
import Name from './Name/index'
import Number from './Number/index'
import React from 'react'
import ShortName from './ShortName/index'
import Tracked from './Tracked/index'
import Type from './Type/index'
import TysiaListColumn from 'DesignSystem/TysiaList/TysiaListColumn/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/Item"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Item.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<ShortName
  viewPath={`${viewPath}/ShortName`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Alert
  viewPath={`${viewPath}/Alert`}
/>
<HideForFuture
  viewPath={`${viewPath}/HideForFuture`}
/>
<MultiValue
  viewPath={`${viewPath}/MultiValue`}
/>
<Tracked
  viewPath={`${viewPath}/Tracked`}
/>
<Mandatory
  viewPath={`${viewPath}/Mandatory`}
/>
<TysiaListColumn
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<EditAction
{...childProps}
  viewPath={`${viewPath}/EditAction`}
/>
)}
</TysiaListColumn>
</div>
{children}
</React.Fragment>)
}